import React from 'reactn';
import autoBind from 'react-autobind';
import Loader from './loader';

export default class BookList extends React.Component {
  constructor(props) {
    super(props);
    autoBind(this);
  }

  componentDidMount() {
    if(this.global.auth && !this.global.loadingBookList) {
      this.dispatch.listBooks();
    }
  }

  render() {
    if(this.global.loadingBookList || this.global.bookList.length < 1) {
      return <Loader/>
    }
    const style= {
      "padding": '1rem', "borderRadius": '1rem', "background": '#eee', "color":"#000",
      "cursor": "pointer", "margin": "1rem", "textAlign": "center", "width":'90%',
      "display": "inline-block", "border":"1px solid #555", "textDecoration": "none"
    };
    return <div style={{"textAlign":"center"}}>{
      this.global.bookList.map(({nickname,he,ru}) => <a key={nickname} style={style}  href={"/" + nickname}>{he} | {ru}</a>)
    }</div>
  }
};

